import { OverlayContainer } from '@angular/cdk/overlay';
import { inject, Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { Meta } from '@angular/platform-browser';

import { SuiTheme, SuiThemeService } from '@semeris/ui';

import { Theme } from '../models/common/themes';

const THEME_COLOR_MAP: Record<Theme, string> = {
  [Theme.Dark]: '#000000',
  [Theme.Light]: '#008ad5',
  [Theme.Next]: '#ffffff',
};

@Injectable({ providedIn: 'root' })
export class ThemeService {
  private readonly suiThemeService = inject(SuiThemeService);
  private readonly overlayContainer = inject(OverlayContainer);
  private readonly metaService = inject(Meta);
  private readonly renderer: Renderer2;

  private readonly classList = [Theme.Light, Theme.Dark, Theme.Next];

  constructor() {
    const rendererFactory = inject(RendererFactory2);
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  public activateTheme(name: Theme): void {
    // Core: apply theme class on <html> via library service
    this.suiThemeService.activateTheme(name as unknown as SuiTheme);

    // App-specific: CDK overlay container
    const overlayEl = this.overlayContainer.getContainerElement();
    this.classList.forEach((c) => {
      this.renderer.removeClass(overlayEl, c);
    });
    this.renderer.addClass(overlayEl, name);

    // App-specific: browser theme-color meta tag
    this.metaService.addTag({
      name: 'theme-color',
      content: THEME_COLOR_MAP[name],
    });
  }
}
